<template>
  <div class="awaiting-candidate">
    <div class="block card">
      <title-block :title="blockTitle" :imagePath="logoBlockUrl" imageAlt="logo"></title-block>
      <div class="block_content mt-2">
        <div class="block_table confirmed-candidate">
          <template v-if="isAdmin">
            <sub-title
              :subTitle="$t('DashboardPageManager.AwaitingCandidateBlock.confirmed_title')"
              :number="latestConfirmedUsers.latest_total"
              color="pink">
            </sub-title>

            <awaiting-candidate-table :users="fixedUsersOfTable(latestConfirmedUsers.users)" userState="confirmed" :entityId="entityId"></awaiting-candidate-table>
            <div class="mt-3 text-center">
              <button class="btn btn-secondary btn-secondary-dark btn-sm" @click="moveToUsersPage('confirmed')">
                {{ $t('DashboardPageManager.AwaitingCandidateBlock.buttons.view_all') }}
              </button>
            </div>
          </template>
          <template v-else>
            <sub-title
              :subTitle="$t('DashboardPageManager.AwaitingCandidateBlock.actived_title')"
              :number="latestActiveUsers.latest_total"
              color="pink">
            </sub-title>
            <awaiting-candidate-table :users="fixedUsersOfTable(latestActiveUsers.users)" userState="active" :entityId="entityId"></awaiting-candidate-table>
            <div class="mt-3 text-center">
              <button class="btn btn-secondary btn-secondary-dark btn-sm" @click="moveToUsersPage('active')">
                {{ $t('DashboardPageManager.AwaitingCandidateBlock.buttons.view_all') }}
              </button>
            </div>
          </template>
        </div>
        <div class="block_table pending-candidate">
          <sub-title
            :subTitle="$t('DashboardPageManager.AwaitingCandidateBlock.pending_title')"
            :number="latestPendingUsers.latest_total"
            color="pink">
          </sub-title>

          <awaiting-candidate-table :users="fixedUsersOfTable(latestPendingUsers.users)" userState="pending" :entityId="entityId"></awaiting-candidate-table>
          <div class="mt-3 text-center">
            <button class="btn btn-secondary btn-secondary-dark btn-sm" @click="moveToUsersPage('pending')">
              {{ $t('DashboardPageManager.AwaitingCandidateBlock.buttons.view_all') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 candidate-progress-block">
      <awaiting-candidate-progress-block
        :numberOfPending="latestPendingUsers.total"
        :numberOfConfirmed="latestConfirmedUsers.total"
        :numberOfActive="latestActiveUsers.total"
        :entityId="entityId"
      />
    </div>
    <awaiting-popup-candidate-detail :entityId="entityId" />
    <candidate-multi-action-popup
      v-if="showMultiActionPopup"
      :user="currentUser"
      :entityId="entityId"
    />
  </div>
</template>

<script type='text/javascript'>
import TitleBlock from '@/components/dashboard/manager/TitleBlock'
import AwaitingCandidateTable from './AwaitingCandidateTable'
import AwaitingCandidateProgressBlock from './AwaitingCandidateProgressBlock'
import SubTitle from "./SubTitle";
import AwaitingPopupCandidateDetail from './AwaitingPopupCandidateDetail'
import CandidateMultiActionPopup from '@/components/users/CandidateMultiActionPopup'
import { mapGetters } from 'vuex';

const DEFAULT_USER = {
  firstName: '',
  last_name: '',
  occupations: []
}
const LIMIT_ROW = 3

export default {
  name: "AwaitingCandidateBlock",
  props: ['currentUser', 'entityId'],
  components: {
    TitleBlock,
    AwaitingCandidateTable,
    AwaitingCandidateProgressBlock,
    SubTitle,
    AwaitingPopupCandidateDetail,
    CandidateMultiActionPopup
  },
  computed: {
    ...mapGetters({
      latestConfirmedUsers: 'dashboard/latestConfirmedUsers',
      latestPendingUsers: 'dashboard/latestPendingUsers',
      latestActiveUsers: 'dashboard/latestActiveUsers',
    }),
    logoBlockUrl() {
      return require('@/assets/img/icons8-pocket-watch-100.png')
    },
    blockTitle() {
      return this.isAdmin ? this.$t('DashboardPageManager.AwaitingCandidateBlock.admin_title') : this.$t('DashboardPageManager.AwaitingCandidateBlock.recruiter_title')
    },
    isAdmin() {
      return this.currentUser.role == 'admin' || this.currentUser.role == 'corporation_admin'
    },
    showMultiActionPopup() {
      return (this.currentUser.role == 'admin' || this.currentUser.role == 'corporation_admin') && this.currentUser.entities.length > 1
    }
  },
  watch: {
    entityId: {
      handler() {
        this.$store.dispatch("dashboard/initDataCandidateBlock", this.entityId);
      }
    }
  },
  methods: {
    fixedUsersOfTable(users) {
      var extraUsers = Array(LIMIT_ROW - users.length).fill(DEFAULT_USER)
      return [...users, ...extraUsers]
    },
    moveToUsersPage(activeTab) {
      this.$router.push({ name: 'Users', params: { entity_id: this.entityId } })
      this.$store.dispatch("users/setActiveTab", activeTab)
    }
  },
  mounted: async function () {
    await this.$store.dispatch("dashboard/initDataCandidateBlock", this.entityId);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/manager/AwaitingCandidateBlock.vue